import { ApiConfig } from "../config/api.config";
import apiService from "./api.service";
import TRANSCRIPT_JSON from "../assets/json/transcript-log-2.json";
const yaml = require('js-yaml');

const getMedia = (limit: number, last_id: string, topic: string, created_by: string[], start_created_at: string, end_created_at: string, is_archived: boolean, is_infographic_available?: boolean) => {
    const params = new URLSearchParams();
    params.set('limit', limit.toString());
    if (last_id) params.set('last_id', last_id);
    if (topic) params.set('topic', topic);
    if (created_by.length > 0) params.set('created_by', created_by.join(','));
    if (start_created_at) params.set('start_created_at', start_created_at);
    if (end_created_at) params.set('end_created_at', end_created_at);
    if (is_archived) params.set('is_archived', is_archived.toString());
    if (is_infographic_available !== undefined) params.set('is_infographic_available', is_infographic_available.toString());
    return apiService.get(ApiConfig.media.get, { params });
}

const getMediaById = (id: string) => {
    const url = ApiConfig.media.getById.replace('{id}', id);
    return apiService.get(url);
}

const addMedia = (id: string, topic: string, description: string, file_name: string) => {
    const data = { id, topic, description, file_name };
    return apiService.post(ApiConfig.media.add, data);
}

const archiveMedia = (id: string) => {
    const url = ApiConfig.media.archive.replace('{id}', id);
    return apiService.post(url);
}

const deleteMedia = (id: string) => {
    const url = ApiConfig.media.delete.replace('{id}', id);
    return apiService.delete(url);
}

const getUsage = () => {
    return apiService.get(ApiConfig.media.getUsage);
}

const restoreMedia = (id: string) => {
    const url = ApiConfig.media.restore.replace('{id}', id);
    return apiService.post(url);
}

const getStatus = (ids: string[]) => {
    const params = new URLSearchParams();
    ids.forEach(id => {
        params.append('ids', id);
    });
    return apiService.get(ApiConfig.media.getStatus, { params });
};

const getSummaryContent = (tone, block) => {
    const transcript = JSON.stringify(TRANSCRIPT_JSON);
    const input_prompt = `You are expert Content Creator 
    Generate content in the following JSON format.
    The JSON format includes:
    {
     'summary' : {
     'title': Provide content from transcript for Cover paragrah part,
     'bullet_points' : [{
     'topic': Create topic from transcript,
     'content' : Provide content base on topic
     }],
     'summarize' : Summarize paragrah
     }
     }
    *bullet_points size is ${block} 
    Return in Thai language
    Ensure the all result Mood and Tone is ${tone} 
    For transcript here:`;


    return apiService.post(ApiConfig.prompt.post, {
        prompt: input_prompt,
        transcript: transcript,
        json: true
    });
}
const getContentInfographic = (tone, block, max_char, size, max_topic_char, speaker_focus) => {
    const transcript = JSON.stringify(TRANSCRIPT_JSON);
    let focus = "";
    if (speaker_focus.length > 0) {
        focus = "4. In topic and content will focus on ";
        speaker_focus.map((item, index) => {
            if (index == speaker_focus.length - 1) {
                focus += " Speaker " + item;
            } else {
                focus += " Speaker " + item + " and ";
            }
        })
        focus += " without return Speaker wording in result";
    }

    const input_prompt = `You are expert Content Creator 
    Content in Transcript base on theses:
    1. Content Tone: ${tone} 
    2. Total topics and contents: ${block} 
    3. All content compatible to infographic size: ${size}
    ${focus}

    Generate content in the following JSON format.
    The JSON format includes:
    {'infographic' : 
    [{ 'topic': 'Provide Topic maximum ${max_topic_char} characters', 'content': 'Provide content base on Topic at least ${max_char} characters'}]
     }
    *bullet_points size is ${block} 
    Return in Thai language
    Ensure the all result Mood and Tone is ${tone} 
    For transcript here:`;


    return apiService.post(ApiConfig.prompt.post, {
        prompt: input_prompt,
        transcript: transcript,
        json: true
    });
}

const MediaService = {
    getMedia,
    getMediaById,
    addMedia,
    archiveMedia,
    deleteMedia,
    getUsage,
    restoreMedia,
    getStatus,
    getContentInfographic,
    getSummaryContent,
};

export default MediaService;